import { Modal } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useEffect, useState } from 'react';
import { UAParser } from 'ua-parser-js';

import GetAppModalContent from './GetAppModalContent';

interface Props {
  visible?: boolean;
  onCancel?: () => void;
  isClosable?: boolean;
}

const GetOurAppModal: React.FC<Props> = ({ visible, onCancel, isClosable }) => {
  const [androidRedirectUrl, setAndroidRedirectUrl] = useState<string | null>(
    null,
  );
  const [hasRedirected, setHasRedirected] = useState(false);

  const screens = useBreakpoint();

  useEffect(() => {
    if (!screens.md && visible) {
      if (typeof window === 'undefined' || hasRedirected) return;

      const parser = new UAParser();
      const result = parser.getResult();
      const deviceType = result.device.type;
      const osName = result.os.name;

      const urlParams = new URLSearchParams(window.location.search);

      const defaultParams: Record<string, string> = {
        utm_source: 'zebralearn',
        utm_medium: 'website',
        utm_campaign: 'download_app',
      };

      const finalParams = new URLSearchParams();

      urlParams.forEach((value, key) => {
        finalParams.set(key, value);
      });

      Object.entries(defaultParams).forEach(([key, value]) => {
        if (!finalParams.has(key)) {
          finalParams.set(key, value);
        }
      });

      const encodedReferrer = encodeURIComponent(finalParams.toString());
      const androidUrl = `https://play.google.com/store/apps/details?id=com.zebralearn.reader&referrer=${encodedReferrer}`;
      const iosUrl =
        'https://apps.apple.com/in/app/zebralearn/id6477746268?utm_source=zebralearn_website';
      setAndroidRedirectUrl(androidUrl);
      if (deviceType === 'mobile' || deviceType === 'tablet') {
        if (osName === 'Android') {
          setHasRedirected(true);
          window.location.href = androidUrl;
        } else if (osName === 'iOS') {
          setHasRedirected(true);
          window.location.href = iosUrl;
        }
      }
    }
  }, [visible]);

  return (
    <Modal
      open={visible}
      centered={true}
      closable={false}
      onCancel={onCancel}
      footer={false}
      className='customModalNoPadding customLoginModal bg-none'
      styles={{
        body: {
          background: 'transparent',
        },
      }}
    >
      <GetAppModalContent
        isClosable={isClosable}
        onCancel={onCancel}
        androidRedirectUrl={androidRedirectUrl}
      />
    </Modal>
  );
};

export default GetOurAppModal;
